var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99993 7.83417C8.00509 7.83417 8.81993 7.01933 8.81993 6.01417C8.81993 5.00901 8.00509 4.19417 6.99993 4.19417C5.99477 4.19417 5.17993 5.00901 5.17993 6.01417C5.17993 7.01933 5.99477 7.83417 6.99993 7.83417Z",
    stroke: "#EE2A7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11158 4.9525C3.26074 -0.0991678 10.7449 -0.0933344 11.8882 4.95833C12.5591 7.92167 10.7157 10.43 9.09991 11.9817C7.92741 13.1133 6.07241 13.1133 4.89408 11.9817C3.28408 10.43 1.44075 7.91583 2.11158 4.9525Z",
    stroke: "#003087"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressLocation);
export default __webpack_public_path__ + "static/media/address-location.8c31ce99.svg";
export { ForwardRef as ReactComponent };